var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.html",value:(_vm.tipData),expression:"tipData",modifiers:{"hover":true,"html":true}}]},[_vm._t("default"),_vm._t("icon",function(){return [_c(`b-icon-${_vm.icon}`,{tag:"component",attrs:{"variant":_vm.variant}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }